import React from 'react';
import './MenuAnonimo.scss';
import LogoBosch from 'assets/logo/LogoBosch.png';
import { NavLink } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { IMenuUsuario } from 'utils/models/interfaces';

const MenuAnonimo = ({ setOpen }: IMenuUsuario) => {
  return (
    <Box mx="auto" display="flex" flexDirection="column" p={3} m={'0 auto'}>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h6" textAlign="left" fontWeight={600} pb={2}>
          Entrar o registrarte
        </Typography>
        <Box height="45px">
          <img src={LogoBosch} alt="logo teatro bosch" />
        </Box>
      </Box>
      <Typography pb={2} fontSize="0.9rem">
        Accedé a tu cuenta para comprar entradas, hacer el seguimiento de los talleres a los que inscribiste o aplicar
        descuentos de socio.
      </Typography>
      <Box display="flex" justifyContent="space-between">
        <NavLink to={'/login'}>
          <Button
            variant="contained"
            color="primary"
            className="botonPrimario botonCuenta"
            onClick={() => setOpen(null)}
          >
            Entrar
          </Button>
        </NavLink>
        <NavLink to={'/registro'}>
          <Button
            variant="outlined"
            color="primary"
            className="botonCuenta botonSecundario"
            onClick={() => setOpen(null)}
          >
            Registrarme
          </Button>
        </NavLink>
      </Box>
    </Box>
  );
};

export default MenuAnonimo;
